import AdminRequestedEventsList from './requestedEventList';

export default AdminRequestedEventsList;
